import request from '@/utils/request'

export function createOrUpdateWorkerTipsItem(data) {
  return request({
    url: '/api/an/worker/createOrUpdateWorkerTipsItem',
    method: 'post',
    data
  })
}

/**
 *
 * @param data
 * @returns {*}
 */
export function getTipsCalendar(data) {
  return request({
    url: '/api/an/worker/getTipsCalendar',
    method: 'get',
    params: data
  })
}

export function getTipListByDate(data) {
  return request({
    url: '/api/an/worker/getTipsListByDate',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/calendar.js